import {useRouter} from 'next/router';
import {useMemo} from 'react';

import {SEARCH_TYPE} from '@/src/app/constants/search';
import useUserActions from '@/src/app/store/user/useUserActions';
import AllCandidates from '@/src/jobPortal/allCandidates/containers/AllCandidates';
import AllVacanciesLayout from '@/src/jobPortal/allVacancies/components/AllVacanciesLayout';
import ClinicVacancies from '@/src/jobPortal/allVacancies/containers/ClinicVacancies';
import ClinicEmployeesSearch from '@/src/Search/containers/ClinicEmployeesSearch';

import MainContainer from '../../main/container/MainContainer';
import MultipleSearch from '../containers/MultipleSearch';
import SearchContainer from '../containers/SearchContainer';

const SearchLayout = () => {
  const {user} = useUserActions();
  const {
    query: {slug},
  } = useRouter();

  const searchComponentNode = useMemo(() => {
    if (slug === SEARCH_TYPE.UNITED) {
      return <MultipleSearch />;
    } else if (slug === SEARCH_TYPE.EMPLOYEES) {
      return <ClinicEmployeesSearch isAllCandidatesPage={false} />;
    } else if (slug === SEARCH_TYPE.ALL_CANDIDATES) {
      return <AllCandidates />;
    } else if (slug === SEARCH_TYPE.CLINIC_VACANCIES) {
      return <ClinicVacancies isAllVacanciesPage={false} />;
    } else if (
      slug === SEARCH_TYPE.ALL_POSITIONS ||
      slug === SEARCH_TYPE.VACANCIES
    ) {
      return (
        <AllVacanciesLayout
          withCommonSearchNavigation={slug === SEARCH_TYPE.VACANCIES}
        />
      );
    } else {
      return <SearchContainer currentUserId={user.user.id} />;
    }
  }, [slug, user]);

  return (
    <MainContainer
      widthContainer={MainContainer.CONTAINER_WIDTH.FULL_WIDTH}
      topOffset={MainContainer.TOP_OFFSET.OFFSET_0}
    >
      {searchComponentNode}
    </MainContainer>
  );
};

export default SearchLayout;
